<!-- <ion-item class="question-item date-item" [formGroup]="form">
	<ion-label position="stacked" *ngIf="label">{{ label }}</ion-label>
	<div class="date-field" [ngClass]="{ error: isError }">
		<ion-icon slot="start" src="./assets/icon/calendar.svg"></ion-icon>
		<ion-datetime [placeholder]="placeholder" max="2050" [cancelText]="'SHARED_TEXT.CANCEL' | translate" [doneText]="'SHARED_TEXT.DONE' | translate" [formControlName]="inputName"></ion-datetime>
	</div>
</ion-item> -->
<ion-item class="question-item date-item" [formGroup]="form">
  <div class="date-trigger-button"
    [class.emptyDateTimeStyle]="(form.get(this.inputName) != null) && (form.get(this.inputName).value === '' || form.get(this.inputName).value === undefined || form.get(this.inputName).value === null)"
    (click)="openPicker()">
    <span *ngIf="displayValue">{{ displayValue }}</span>
    <span *ngIf="!displayValue && isPlaceholderEnabled">{{ placeholder || 'Select' }}</span>
    <span *ngIf="!displayValue && !isPlaceholderEnabled">Select date</span>
  </div>
  <ion-modal [isOpen]="isPickerOpen" [backdropDismiss]="false" (didDismiss)="onModalDismiss()"
             cssClass="ion-datetime-button-overlay">
    <ng-template>
      <div class="datetime-picker-wrapper">
        <div class="datetime-picker-header">
          <ion-button fill="clear" (click)="onCancelClick()">{{ 'SHARED_TEXT.CANCEL' | translate }}</ion-button>
          <ion-button fill="clear" (click)="onConfirmClick()"><strong>{{ 'SHARED_TEXT.DONE' | translate }}</strong></ion-button>
        </div>
        <ion-datetime
          presentation="date"
          [preferWheel]="true"
          [placeholder]="placeholder"
          max="2050"
          [formControlName]="inputName"
          [id]="uniqueId"
          (ionChange)="onDateChange($event)"
        ></ion-datetime>
      </div>
    </ng-template>
  </ion-modal>
</ion-item>
